import React from 'react'
import strings from 'mobile_web/strings'
import { useSelector } from 'react-redux'
import { RootStoreState } from 'mytours-read-common'

interface Props {
	onClick: React.MouseEventHandler<HTMLDivElement>
	isFavourited: boolean
}
export const HeaderFavouriteButton: React.FC<Props> = ({ onClick, isFavourited }) => {
	const appMetaData = useSelector((state: RootStoreState) => state.settings.appMetaData)
	const icon = isFavourited ? 'fas fa-heart' : 'fal fa-heart'
	const label = isFavourited ? strings.unfavourite : strings.favourite
	if (!appMetaData.favorites_enabled) {
		return null
	}
	return (
		<div className="header-favourite-button-icon-container" onClick={onClick}>
			<i className={icon} aria-label={label} />
		</div>
	)
}
